"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _es6Promise = _interopRequireDefault(require("es6-promise"));

var _lodash = _interopRequireDefault(require("lodash"));

require("whatwg-fetch");

var _user = _interopRequireDefault(require("../user/user"));

var _farm = _interopRequireDefault(require("../farm/farm"));

var _farm2 = require("../farm/lib/farm");

var _stallvisite = _interopRequireDefault(require("../stallvisite/stallvisite"));

var _projectState = _interopRequireDefault(require("../project-state"));

var _farmComment = _interopRequireDefault(require("../farm-comment"));

var _translate = _interopRequireDefault(require("../translate"));

var _conf = _interopRequireDefault(require("../../conf"));

var _fetchUtils = _interopRequireDefault(require("../../fetchUtils"));

var _deleteButtonProject = _interopRequireDefault(require("./../delete-button-project"));

var _authorisation = _interopRequireDefault(require("../authorisation"));

var _gitChangesetLink = _interopRequireDefault(require("../git-changeset-link"));

var _projectStatus = _interopRequireDefault(require("../project-status"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

_es6Promise.default.polyfill();

var DeleteButtonAuthorised = new _authorisation.default(['admin', 'projectresponsible'], ['stallvisite'], false)(_deleteButtonProject.default);

var StallvisiteRelease = /*#__PURE__*/function (_React$Component) {
  _inherits(StallvisiteRelease, _React$Component);

  function StallvisiteRelease(props) {
    var _this;

    _classCallCheck(this, StallvisiteRelease);

    _this = _possibleConstructorReturn(this, (StallvisiteRelease.__proto__ || Object.getPrototypeOf(StallvisiteRelease)).call(this, props));
    _this.state = {
      subMenuConfig: [{
        label: props.t('status'),
        anchor: 'status'
      }, {
        label: props.t('User'),
        anchor: 'user-data'
      }, {
        label: props.t('farm'),
        anchor: 'farm-data'
      }, {
        label: props.t('Projectdata'),
        anchor: 'project-data'
      }, {
        label: props.t('Projects'),
        anchor: 'other-projects'
      }],
      userLoaded: false,
      user: {},
      project: null,
      farm: (0, _farm2.initialFarm)(),
      projectLoaded: false,
      salutations: [],
      cantons: []
    };
    _this.addressTypes = [{
      id: 1,
      name: 'datamaster-forms:::general-own-address'
    }, {
      id: 2,
      name: 'datamaster-forms:::general-other-address'
    }];

    if (props.getSubMenuConfig && _this.state.subMenuConfig) {
      props.getSubMenuConfig(_this.state.subMenuConfig);
    }

    _this.onFileRemove = _this.onFileRemove.bind(_assertThisInitialized(_this));
    _this.onFileUploaded = _this.onFileUploaded.bind(_assertThisInitialized(_this));
    _this.saveProject = _this.saveProject.bind(_assertThisInitialized(_this));
    _this.onProjectDataUpdate = _this.onProjectDataUpdate.bind(_assertThisInitialized(_this));
    _this.updateFarmData = _this.updateFarmData.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(StallvisiteRelease, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var farmId = this.props.match.params.farmId;
      fetch(_conf.default.api.stallvisiteFromFarmApiUrl(this.props.i18n.language, farmId), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (project) {
        _this2.setState(function (prev) {
          project.addresstype = _this2.addressTypes.find(function (addressType) {
            return parseInt(project.addresstype) === addressType.id;
          });
          prev.project = project;
          prev.projectLoaded = true;
          return prev;
        });
      }).catch(function (err) {
        if (err.error.status === 404) {
          _this2.props.history.push('/not-found');
        }
      });
      fetch("".concat(_conf.default.api.farmApiUrlTemplate(this.props.i18n.language), "/").concat(parseInt(farmId)), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (farm) {
        _this2.setState(function (prev) {
          prev.farm = farm;
          return prev;
        });
      }).catch(function (err) {
        void 0;
      });
      fetch(_conf.default.api.userFromFarmApiUrlTemplate(this.props.i18n.language, farmId), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (user) {
        _this2.setState(function (prev) {
          prev.user = user;
          prev.userLoaded = true;
          return prev;
        });
      });
      fetch(_conf.default.api.salutationApiUrlTemplate(this.props.i18n.language), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (salutations) {
        _this2.setState(function (prev) {
          prev.salutations = salutations;
          return prev;
        });
      });
      fetch(_conf.default.api.cantonApiUrlTemplate(this.props.i18n.language), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (cantons) {
        _this2.setState(function (prev) {
          prev.cantons = cantons;
          return prev;
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;

      if (!this.state.project || !this.state.farm) {
        return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
          className: "loader loader--medium"
        }));
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "comp-schub-release detail-view"
      }, /*#__PURE__*/_react.default.createElement("h1", {
        className: "title"
      }, t('stable visits'), /*#__PURE__*/_react.default.createElement("span", {
        className: "icon-list"
      }, /*#__PURE__*/_react.default.createElement(DeleteButtonAuthorised, {
        id: parseInt(this.props.match.params.farmId),
        history: this.props.history,
        urlTemplate: _conf.default.api.stallvisiteFromFarmApiUrl
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x space-4"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 medium-12 large-11 xlarge-10"
      }, /*#__PURE__*/_react.default.createElement("h2", {
        id: "status"
      }, t('release status')), /*#__PURE__*/_react.default.createElement(_projectState.default, {
        projectKey: 'stallvisite',
        farmId: this.props.match.params.farmId,
        projectData: this.state.project
      }), /*#__PURE__*/_react.default.createElement(_gitChangesetLink.default, {
        changesetUrl: this.state.project.changeSet,
        text: t('Stallvisite changeset link')
      }), /*#__PURE__*/_react.default.createElement(_farmComment.default, {
        id: parseInt(this.props.match.params.farmId)
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 medium-12 large-11 xlarge-10"
      }, this.state.userLoaded && /*#__PURE__*/_react.default.createElement(_user.default, {
        name: "User",
        user: this.state.user,
        anchorId: this.state.subMenuConfig[1].anchor
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 medium-12 large-11 xlarge-10"
      }, this.state.farm ? /*#__PURE__*/_react.default.createElement(_farm.default, {
        name: "Farm",
        farm: this.state.farm,
        id: this.props.match.params.farmId,
        anchorId: this.state.subMenuConfig[2].anchor,
        updateFarmData: this.updateFarmData
      }) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
        className: "loader loader--medium"
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 medium-12 large-11 xlarge-10"
      }, this.state.projectLoaded ? /*#__PURE__*/_react.default.createElement(_stallvisite.default, {
        id: this.props.match.params.farmId,
        t: t,
        history: this.props.history,
        name: "Stallvisite",
        project: this.state.project,
        anchorId: this.state.subMenuConfig[3].anchor,
        images: this.state.farm.images,
        documents: this.state.farm.documents,
        cantons: this.state.cantons,
        salutations: this.state.salutations,
        addressTypes: this.addressTypes,
        onFileRemove: this.onFileRemove,
        onFileUploaded: this.onFileUploaded,
        onSaveProject: this.saveProject,
        onProjectDataUpdate: this.onProjectDataUpdate
      }) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
        className: "loader loader--medium"
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: 'grid-x grid-padding-x'
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'cell small-12 medium-12 large-11 xlarge-10'
      }, this.state.userLoaded && /*#__PURE__*/_react.default.createElement(_projectStatus.default, {
        userId: this.state.user.id,
        t: t,
        i18n: this.props.i18n,
        history: this.props.history,
        anchorId: 'other-projects',
        ignoreProject: 'stallvisite'
      }))));
    }
    /**
     *
     * @param fieldName
     * @param value
     */

  }, {
    key: "onProjectDataUpdate",
    value: function onProjectDataUpdate(fieldName, value) {
      this.setState(function (prev) {
        prev.project[fieldName] = value;
        return prev;
      });
    }
    /**
     *
     * @param data
     */

  }, {
    key: "updateFarmData",
    value: function updateFarmData(data) {
      this.setState(function (prev) {
        prev.farm = _lodash.default.assign(prev.farm, data);
        return prev;
      });
    }
    /**
     *
     * @param id
     * @param type
     */

  }, {
    key: "onFileRemove",
    value: function onFileRemove(id, type) {
      this.setState(function (prev) {
        prev.farm[type] = prev.farm[type].filter(function (file) {
          return file.id !== id;
        });
        return prev;
      });
    }
    /**
     *
     * @param files
     * @param type
     */

  }, {
    key: "onFileUploaded",
    value: function onFileUploaded(files, type) {
      this.setState(function (prev) {
        prev.farm[type] = prev.farm[type].concat(files);
        return prev;
      });
    }
    /**
     *
     * @returns {Promise<Response>}
     */

  }, {
    key: "saveProject",
    value: function saveProject() {
      var _this3 = this;

      var project = this.beforeSaveProject(_lodash.default.cloneDeep(this.state.project));
      return fetch(_conf.default.api.stallvisiteFromFarmApiUrl(this.props.i18n.language, this.state.farm.id), {
        method: 'PUT',
        body: JSON.stringify(project),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(_fetchUtils.default.checkStatus).then(function (updatedProject) {
        _this3.setState(function (prev) {
          prev.project = updatedProject;
          prev.project.addresstype = _this3.addressTypes.find(function (addressType) {
            return parseInt(prev.project.addresstype) === parseInt(addressType.id);
          });
          return prev;
        });
      });
    }
    /**
     *
     * @param project
     * @returns {*}
     */

  }, {
    key: "beforeSaveProject",
    value: function beforeSaveProject(project) {
      delete project.farm; // we do not send farm information
      // make sure addressfields are present if addresstype has id=2

      if (project.addresstype.id === 2) {
        project.salutation = project.salutation || {};
        project.first_name = project.first_name || '';
        project.last_name = project.last_name || '';
        project.eventlocation = project.eventlocation || '';
        project.street = project.street || '';
        project.zip = project.zip || '';
        project.city = project.city || '';
        project.canton = project.canton || {};
      } // make sure addressfields absent if addresstype has id=1


      if (project.addresstype.id === 1) {
        delete project.salutation;
        delete project.first_name;
        delete project.last_name;
        delete project.eventlocation;
        delete project.street;
        delete project.zip;
        delete project.city;
        delete project.canton;
      }

      return project;
    }
  }]);

  return StallvisiteRelease;
}(_react.default.Component);

StallvisiteRelease.propTypes = {
  t: _propTypes.default.func.isRequired,
  match: _propTypes.default.shape({
    params: _propTypes.default.shape({
      farmId: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
    })
  }),
  getSubMenuConfig: _propTypes.default.func,
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string
  }),
  history: _propTypes.default.shape({
    push: _propTypes.default.func
  })
};

var _default = (0, _translate.default)(StallvisiteRelease);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/stallvisite-release/release.js
// module id = 716
// module chunks = 0